/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainer1_settings = {
    readonly disableCommenting: {
        readonly enabled: boolean;
    };
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_settings" | "ReplyListContainer2_settings">;
    readonly " $refType": "ReplyListContainer1_settings";
};
export type ReplyListContainer1_settings$data = ReplyListContainer1_settings;
export type ReplyListContainer1_settings$key = {
    readonly " $data"?: ReplyListContainer1_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainer1_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainer1_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "DisableCommenting",
            "kind": "LinkedField",
            "name": "disableCommenting",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enabled",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_settings"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer2_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '675a37801382b8401b68cc02430df13c';
export default node;
